/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import * as consts from '../../../../const';

const placeholderStyle = {
  height: '13px',
  width: '80%',
  borderRadius: '15px',
  background: '#ECECEC'
};
const Placeholder = () => <div style={placeholderStyle} />;

export const getPlaceholderRows = (noOfRows) => {
  const getRow = (_, id) => ({
    id,
    columns: [
      { columnData: Placeholder },
      { columnData: Placeholder },
      { columnData: Placeholder },
      { columnData: Placeholder },
      { columnData: Placeholder },
      { columnData: Placeholder }
    ]
  });

  return [...Array(noOfRows)].map(getRow);
};

export const emptyData = () => (
  <div className="no-participants-data">
    <div className="material-icons">info</div>
    <div className="no-participants-data-label">{consts.NO_PARTICIPANTS_DATA}</div>
  </div>
);

export const getLocationMetadata = ({ location, match }) => {
  const userManagementOrgFlow = location && location.pathname.includes('manager/usermanagement/organization');

  const userManagementFlow = !userManagementOrgFlow && location && location.pathname.includes('manager/usermanagement');

  const { organizationId = '', organizationName = '' } = (match && match.params) || {};

  return {
    userManagementOrgFlow,
    userManagementFlow,
    organizationId,
    organizationName
  };
};

export const getSelectedFilter = (filters) => (options, field, defaultLabel) => {
  const selectedOption = options.find(({ value }) => value === filters[field]);
  return { label: selectedOption ? selectedOption.label : defaultLabel };
};
